import { ToggleInput } from 'containers/jobs-board/components/ToggleInput'
import { useJobsSearchContext } from 'containers/jobs-board/context/JobsSearchContext'

export const RelocationFilter = () => {
    const { filters, updateFilters } = useJobsSearchContext()

    const handleRelocationToggle = () => {
        updateFilters({
            sponsorshipOffered: filters.sponsorshipOffered ? undefined : true,
        })
    }

    return (
        <ToggleInput
            labelText="Relocation"
            onToggle={handleRelocationToggle}
            isChecked={filters.sponsorshipOffered ?? false}
        />
    )
}
